import React, { forwardRef } from 'react';
import { useIntl } from 'react-intl';
import { Controller } from 'react-hook-form';
import { get, has } from 'lodash';
import { NumericFormat } from 'react-number-format';
import { InputAdornment } from '@mui/material';

import TextFieldDefault from '../../TextFieldDefault';

function FormBudget({
  control,
  name = 'budget',
  errors,
  currencySymbol,
  hiddenLabel = false,
  required = false,
  placeholder,
}: any) {
  const intl = useIntl();

  const NumericFormatCustom = forwardRef(({ onChange, ...other }: any, ref) => (
    <NumericFormat
      {...other}
      getInputRef={ref}
      onValueChange={(values: any) => {
        onChange(values.value);
      }}
      valueIsNumericString
      thousandSeparator=" "
      decimalScale={0}
    />
  ));

  NumericFormatCustom.displayName = 'NumericFormatCustom';

  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { ref, ...rest } }: any) => (
        <TextFieldDefault
          {...rest}
          inputRef={ref}
          label={!hiddenLabel && intl.formatMessage({ id: 'POST_FORM.BUDGET' })}
          data-testid="post-form-budget"
          placeholder={placeholder || intl.formatMessage({ id: 'POST_FORM.BUDGET_PLACEHOLDER' })}
          error={has(errors, name)}
          helperText={get(errors, `${name}.message`)}
          required={required}
          slotProps={{
            htmlInput: { 'aria-label': intl.formatMessage({ id: 'POST_FORM.BUDGET' }) },
            input: {
              startAdornment: <InputAdornment position="start">{currencySymbol}</InputAdornment>,
              inputComponent: NumericFormatCustom,
            },
          }}
        />
      )}
    />
  );
}

export default FormBudget;
